import { Activity, Home, Plane, Umbrella } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const TYPE_META: Record<string, { label: string; color: string; Icon: LucideIcon }> = {
  vacation: { label: 'Vacation',   color: '#2563eb', Icon: Plane },
  sick:     { label: 'Sick leave', color: '#dc2626', Icon: Activity },
  personal: { label: 'Personal',   color: '#d97706', Icon: Umbrella },
  remote:   { label: 'Remote',     color: '#16a34a', Icon: Home },
};
